import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import logo from "../../assets/logo.png";

export const FallbackSpinner = ({ sx }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box component="img" src={logo} alt="brand" sx={{ width: 80, ...sx }} />
      </Box>
      <CircularProgress disableShrink sx={{ mt: 6 }} />
    </Box>
  );
};
